<script lang="ts">
    import dayjs from 'dayjs'
    import { createEventDispatcher } from 'svelte'
    import type { Business } from '../../modules/prospectApi/business/business.entity'
    import type { Audience } from '../../modules/eventsApi/audiences/audience'
    import { each } from 'svelte/internal'
    import Fa from 'svelte-fa'
    import { faUser } from '@fortawesome/free-solid-svg-icons'
    import { faGoogle } from '@fortawesome/free-brands-svg-icons'
    const dispatch = createEventDispatcher()

    let utils = window.api.utils.utils

    export let business: Business = null
    export let selected: boolean = false
    export let toggleSelection: boolean = false
    export let included: boolean = false
    export let audiences: Audience[] = []

    $: {
        selected = toggleSelection
    }

    function showPerson(businessId) {}

    function friendlyDate(date) {
        if (!date) return '-'
        return dayjs(date).format('DD/MM/YYYY')
    }

    function friendlyPhone(phone: string) {
        return utils.phoneFriendly(utils.phoneNormalize(phone, '00'))
    }

    function friendlyDocument(doc: string) {
        return utils.documentFriendly(doc)
    }

    function toggleSelect() {
        selected = !selected
        dispatch('toggle', selected)
    }

    function toTitleCase(str) {
        if (!str) return ''
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
    }

    function openTab(url) {
        window.open(url, '_blank').focus()
    }
</script>

{#if business}
    <div class="card" class:included class:selected on:click={toggleSelect}>
        {#if included && audiences.length === 0}
            <div class="included-tag">Já adicionado a um público</div>
        {/if}
        {#each audiences as audience}
            <div class="included-tag nowrap">No público: {audience.title}</div>
        {/each}
        <div class="card_content">
            <div class="google">
                <div class="label">
                    No Google | {business.googleReviews}
                    {business.googleReviews > 1 ? 'avaliações' : 'avaliação'}
                </div>
                <div class="name">{toTitleCase(business.name).slice(0, 70)}</div>
                <div class="img" style="background-image: url('{business.googleImage}');" />
                <div class="item">
                    {business.categories[0].category.name}
                </div>
                <div class="item">
                    {business.googleAddress}, {business.googleNumber} - CEP {business.googleCEP}
                </div>
                <div class="item">
                    {business.city.name} / {business.city.state}
                </div>
                <div class="item">Telefone: {friendlyPhone(business.googlePhone)}</div>
                <div class="item mt-1">
                    <button on:click|stopPropagation={() => openTab(business.googleUrl)} class="btn btn-primary btn-sm" title="Abrir no Google"
                        ><Fa icon={faGoogle} /></button
                    >
                    {#if window.store.token.permissions.persons.show}
                        <button
                            class="btn btn-primary btn-sm"
                            title="Procurar em Pessoas"
                            on:mousedown|stopPropagation
                            on:click|stopPropagation={() => {
                                window.person('show', business.googlePhone, 4)
                            }}
                        >
                            <Fa icon={faUser} />
                        </button>
                    {/if}
                </div>
            </div>
            <div class="gov">
                <div class="label">Na Receita</div>
                {#if business.govDate}
                    <div class="item">CNPJ: {friendlyDocument(business.cnpj) || '-'}</div>
                    <div class="item">Abertura: {friendlyDate(business.govDate)}</div>
                    <div class="item">Sócio 1: {business.govSocio1 || '-'}</div>
                    <div class="item">Sócio 2: {business.govSocio2 || '-'}</div>
                    <div class="item">Sócio 3: {business.govSocio3 || '-'}</div>
                    <div class="item">Telefone: {friendlyPhone(business.govPhone) || '-'}</div>
                    <div class="item">E-Mail: {business.govEmail || '-'}</div>
                {:else}
                    <div class="item"><i>Sem dados para exibir</i></div>
                {/if}
            </div>
        </div>
    </div>
{:else}
    <div class="text-muted text-center">Nenhum dado de prospecção encontrado</div>
{/if}

<style>
    .card {
        border: 4px solid #33333300;
        border-radius: 8px;
        overflow: hidden;
        margin: 16px 8px;
        flex: 1 1 365px;
        min-width: 350px;
        max-width: 560px;
        overflow: hidden;
        background-color: #292929;
        position: relative;
        cursor: pointer;
    }
    .selected {
        border: 4px solid #ffc107 !important;
    }
    .included-tag {
        background-color: #aa8003;
        border-radius: 4px;
        padding: 0px 4px;
        margin: 2px;
        font-size: 13px;
    }
    .card_content .img {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        height: 200px;
        background-color: #202020;
        margin: 2px 6px 4px 12px;
        border-radius: 4px;
    }
    .card_content {
        color: #ccc;
    }
    .card_content .label {
        padding: 2px 4px;
        color: #328866;
        margin-top: 4px;
        font-size: 17px;
    }
    .card_content .name {
        font-weight: 300;
        font-size: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0px 4px 10px 12px;
        line-height: 100%;
    }
    .card_content .item {
        padding: 0px 4px 0px 12px;
        color: #bbbbbb;
        font-size: 15px;
    }
    .card_content .item i {
        color: #999;
    }
</style>
